export default __webpack_public_path__ + "static/media/cableyellow.86a1fc4a.png";